export function urlPathJoin(...paths: string[]) {
    return paths.map(p => p.endsWith("/") ? p : `${p}/`).map(p => p.startsWith("/") ? p.slice(1) : p).join("");
}
